module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/widgets/activity-scroll/activity-scroll.component.scss
// module id = ./src/app/shared/components/widgets/activity-scroll/activity-scroll.component.scss
// module chunks = main